import I18n from 'I18n';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const LanguageName = ({
  languageKey,
  shouldShowLanguageColor
}) => {
  const key = `SharedI18nStrings.languageNames.${languageKey}`;

  // @ts-expect-error untyped `lookup` module
  return I18n.lookup(key) ? /*#__PURE__*/_jsx(Text, {
    as: "span",
    color: shouldShowLanguageColor ? 'text-tertiary-disabled' : undefined,
    children: ` (${I18n.text(key)})`
  }) : null;
};
export default LanguageName;